import './abasicadrienn/style';
import FormStructure from './abasicadrienn/form_structure';

export default FormStructure;